import ActivitiesBoard from "@/components/ActivitiesBoard";
import { useAuth } from "@/context/AuthContext";

export default function AgencyActivities() {
  const { user } = useAuth();
  const isAgency = user?.role === "agency";
  return (
    <ActivitiesBoard
      actor="agenzia"
      title={isAgency ? "Le mie attività" : "Attività Agenzie"}
      subtitle={isAgency ? "Registra le tue attività e i tuoi impegni: visite e contatti verso i clienti." : "Visite e contatti svolti dalle agenzie verso i clienti."}
      readOnly={!["admin", "agency", "back_office"].includes(user?.role)}
    />
  );
}
